import { render, staticRenderFns } from "./ConfirmBirthday.vue?vue&type=template&id=4ef87432&scoped=true"
import script from "./ConfirmBirthday.vue?vue&type=script&lang=js"
export * from "./ConfirmBirthday.vue?vue&type=script&lang=js"
import style0 from "./ConfirmBirthday.vue?vue&type=style&index=0&id=4ef87432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef87432",
  null
  
)

export default component.exports